import { toast } from "react-toastify";

import { BASE_URL } from "@/common/api/axios";
import { usePermissions } from "@/common/contexts/Permissions.context";
import { DownloadIcon } from "@/components/icon";

export default function DownloadQuotesButton() {
  const { company } = usePermissions();
  const handleDownload = async () => {
    if (!company) {
      toast.error("Something went wrong");
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/quotes/download?take=10000`, {
        method: "GET",
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error("Failed to download file.");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `quotes_${company.companyName}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while downloading the file.");
    }
  };
  return (
    <button
      onClick={handleDownload}
      className="flex py-2 px-3 gap-2 text-primary border border-transparent font-kanit bg-primaryDim rounded-lg hover:border-primary transition-[border-color]"
    >
      <DownloadIcon />
      Download in CSV File
    </button>
  );
}
